import React, { memo, useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import { ProductRecommendation, RecommendedProduct } from '../../../../types';

import * as S from './styles';

type OwnProps = {
  columns?: number;
  items: ProductRecommendation[];
  limit?: number;
  onClick: (product: RecommendedProduct) => void;
};

const Recommendations = ({ columns = 4, items, limit, onClick }: OwnProps) => {
  const { linkTo } = useContext(AppContext);

  return (
    <>
      {items
        .filter((item, index) => !limit || index < limit)
        .map(({ product }) => {
          if (!product) return null;

          return (
            <S.ProductCard
              columns={columns}
              key={product.id}
              name={product.name}
              image={
                product.media?.first && (
                  <S.ProductImage
                    name={product.name}
                    src={product.media.first}
                  />
                )
              }
              price={product.price?.regular}
              link={linkTo('product', product)}
              onClick={() => onClick(product)}
            />
          );
        })}
    </>
  );
};

export default memo(Recommendations);
